import { useCallback, useEffect, useRef, useState } from "react";
import { IHeaderParams } from "ag-grid-community";
import UrgencyIcon from "../assets/images/infoIcon.svg";
import { PiGrid, PiModal, PiModalBody, PiSpinner } from "pixel-kit";
import crossImg from "../../src/assets/images/cross.svg";

import {
  CloseButtonContainer,
  CloseIcon,
} from "../components/Quote-components/quote-approve-model/quote-approve-model-components";
import EndpointUrl from "../core/apiEndpoints/endPoints";
import { triggerApi } from "../services";
import { FormBodyOverFlow } from "../components/Quote-components/Quote-filter/quote-filter-components";
import TableGrid from "../components/tablegrid";

import { SpinnerDiv } from "../components/CustomerHeader/customer-header-components";

const CustomHeader = (props: IHeaderParams  & { type?: string }) => {
  const { displayName , type} = props;
  const [isOpen, setOpen] = useState(false);
  const [tableData, setTableData] = useState<any>([]);
  const isMountedRef = useRef(true);
  const [isLoading, setIsLoading] = useState(false);
  
  const getQuoteList = useCallback(() => {
    setIsLoading(true);
    const apiUrl = type === "quotes" ? `${EndpointUrl.Quote}?page=1&perPage=3&apiSource=portal` : `${EndpointUrl.rmaRequest}?page=1&perPage=3&apiSource=portal`;
    const apiObject = {
      payload: {},
      method: "GET",
      apiUrl: apiUrl,
      headers: {},
    };

    triggerApi(apiObject)
      .then((res: any) => {
        if (
          isMountedRef.current &&
          res.result.success &&
          res.result.status_code === 200
        ) {
          setTableData(res.result?.data?.pop_status_information || []);
          setIsLoading(false);
        }
      })
      .catch((err: string) => {
        console.log(err);
        setIsLoading(false);
      });
  }, [type]);

  useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
      setTableData([]); // Clear data when unmounting (optional)
    };
  }, []);

  // Define column definitions
  const columndata = [
    {
      headerName: "Status Code", 
      field: "status_code", 
      
    },
    {
      headerName: "Status Information",
      field: "status_information",
      // cellRenderer: (params: any) => {
      //   let iconSrc = "";
      //   let statusText = "No Information";

      //   switch (params.value) {
      //     case "Approved":
      //       iconSrc = approvedIcon;
      //       statusText = "Approved";
      //       break;
      //     case "Rejected":
      //       iconSrc = rejectedIcon;
      //       statusText = "Rejected";
      //       break;
      //     case "Closed":
      //       iconSrc = closedIcon;
      //       statusText = "Closed";
      //       break;
      //     case "Waiting on Customer Approval":
      //       iconSrc = pendingIcon;
      //       statusText = "Waiting on Customer Approval";
      //       break;
      //     case "Won So created":
      //       // iconSrc = wonIcon;
      //       statusText = "Won So created";
      //       break;
      //   }

      //   return `<div style="display: flex; align-items: center; gap: 8px;">
      //             ${iconSrc && `<img src="${iconSrc}" alt="${statusText}" style="width: 20px; height: 20px;" />`}
      //             <span>${statusText}</span>
              
                  
      //           </div>`;
      // },
    },
  ];
  return (
    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
      <span className="ag-header-cell-text">{displayName}</span>
      <img
        src={UrgencyIcon}
        alt={`${displayName} icon`}
        style={{ width: "20px", height: "20px", cursor: "pointer" }}
        onClick={() => {
          getQuoteList();
          setOpen(true);
        }}
      />
      {isOpen && (
        <PiModal isOpen={isOpen} className="custommodel-ag-grid">
          <CloseButtonContainer
            className="pointer_event"
            onClick={() => setOpen(false)}
            style={{cursor: "pointer"}}
          >
            <CloseIcon title="close" className="pointer_event">
              <img src={crossImg} alt="Close" />
            </CloseIcon>
          </CloseButtonContainer>
          <div style={{ height: "300px", position: "relative" }}>
            <PiModalBody>
              <FormBodyOverFlow style={{ height: "100%" }}>
                <TableGrid>
                  {isLoading ? (
                    <SpinnerDiv
                      style={{
                        position: "absolute",
                        top:"50%",
                        left: "50%",
                        transform: 'translate(-50%, -50%)'
                      }}
                    >
                      <PiSpinner
                        color="primary"
                        size={50}
                        libraryType="atalskit"
                      />
                    </SpinnerDiv>
                  ) : (
                    <PiGrid
                      className="model-ag-grid"
                      columns={columndata}
                      mode="static"
                      rowData={tableData}
                      rowHeight={40}
                    />
                  )}
                </TableGrid>
              </FormBodyOverFlow>
            </PiModalBody>
          </div>
        </PiModal>
      )}
    </div>
  );
};

export default CustomHeader;
